import { SET_COMMAND_LIST } from "../actions/commandList"

const initialState = {
    commandList: null
}

const commandListReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_COMMAND_LIST:
            return {
                ...state,
                commandList: action.payload
            }
        default:
            return state
    }
}

// const userSessionDataReducer =()

export default commandListReducer